import React from "react";
import { FaSignOutAlt } from "react-icons/fa";
import styles from "./adminHeader.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminHeader = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogOut = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className={styles["dash-header"]}>
      <img src="/logo.png" alt="Sports Hub Logo" className={styles.logo} />
      <div className={styles["dash-buttons"]}>
        <button onClick={handleLogOut} className={styles["dash-logout-btn"]}>
          <FaSignOutAlt /> Log Out
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
